import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PayForFree from './PayForFree';
import { usePackagesContext } from '../../../context/packages_context';
import { ICON_BOX_SEAM, ICON_MARK } from '../../../utils/icons';


const PackageData = ({ allPackages }) => {

      const [packageInfo, setPackageInfo] = useState({});


      let navigate = useNavigate();
      let location = useLocation();
      const [path] = useState(location.pathname);


      const {
            openPayForFree
      } = usePackagesContext();

      function openPaymentModal(e) {
            setPackageInfo(e);
            openPayForFree();
      }

      // Route to Paymet Page
      function payPage(e) {
            console.log(e);
            navigate(
                  `/user/settings/packages/pay/${ e.id }`,
                  { state: e }
            );
      }
      // Route to Paymet Page

      return (
            <>
                  {
                        allPackages?.map((item) => {
                              const { amount_th, features, name, duration_days } = item;
                              let newFeatures = features || [];
                              return (
                                    <div className="col-md-6 col-lg-4 mb-4 text-start" key={item?.name}>
                                          <div className="card pry-border h-100 py-5 px-3 br-md">
                                                <div className="card-body">
                                                      <h5 className='text-end pry-text'>
                                                            {ICON_BOX_SEAM}
                                                      </h5>
                                                      <p className="pry-text  mb-3">{name}</p>
                                                      <h3 className="pry-text mb-3"> ₦ {amount_th}</h3>
                                                      <p className="pry-text mb-4"> {duration_days} days</p>
                                                      <hr className='pry-border' />
                                                      <div className="">
                                                            <p className=" mb-3"> Includes:</p>

                                                            <ul className="list-unstyled">
                                                                  {newFeatures?.map(({ details }, i) => <li className="list-item mb-2" key={i}>
                                                                        {ICON_MARK}
                                                                        {details}
                                                                  </li>
                                                                  )}
                                                            </ul>
                                                      </div>
                                                </div>
                                                <div className="text-center px-4">
                                                      {path === '/' ?
                                                            <>
                                                                  <Link to="/register">
                                                                        <button className="pry-text br-xlg sec-bold btn shadow-none w-100 m-0 mb-3 ">
                                                                              Get Started
                                                                        </button>
                                                                  </Link>
                                                            </>
                                                            :
                                                            <>
                                                                  {path === '/about' ?
                                                                        <Link to="/register">
                                                                              <button className="pry-text br-xlg sec-bold btn shadow-none w-100 m-0 mb-3 ">
                                                                                    Get Started
                                                                              </button>
                                                                        </Link> :
                                                                        <>
                                                                              {
                                                                                    name === 'Free Tier' ?
                                                                                          <button className="pry-text br-xlg sec-bold btn shadow-none w-100 m-0 mb-3 "
                                                                                                onClick={() => openPaymentModal(item)}>Start for Free ✨
                                                                                          </button>
                                                                                          :
                                                                                          <button className="pry-text br-xlg sec-bold btn shadow-none w-100 m-0 mb-3 "
                                                                                                onClick={() => payPage(item)}>Subscribe
                                                                                          </button>
                                                                              }
                                                                        </>

                                                                  }
                                                            </>
                                                      }

                                                </div>

                                          </div>
                                    </div>

                              );
                        }
                        )
                  }

                  <PayForFree
                        {...packageInfo}
                  />
            </>
      );
};

export default PackageData;